module.exports = __webpack_public_path__ + "img/郭天羿.00a01e81.jpg";